import { chakra } from '@chakra-ui/react'
import NextImage from 'next/image'

/**
 * This component merges Chakra and Next's Image components.
 * Chakra Image = support for all the styled-component stuff
 * Next Image = automatic optimization and CDN use etc.
 *
 * NOTE! - src should be a passed module, NOT a string URL, for the best optimization.
 * Example: <ChakraNextImage src={require('@public/assets/path/to/image.png')} />
 */

export const ChakraNextImage = chakra(NextImage)
